import { Link } from "react-router-dom";
import { Button, Nav, Navbar, NavbarBrand, NavItem, NavLink } from "reactstrap";
import BonusPoints from "../../../components/bonifiedInteractions/BonusPoints";
import keycloak from "../../../keycloak";
import { isLoggedIn } from "../../../store/actions/LoginActions";
import { UrlPathBonifiedInteractions, UrlPathMain } from "../../../url";
import { SelectTheme } from "../../SwitchTheme";
import logo from "../images/logo.png";

export const Header = () => {
  const logoutAndRedirect = () => {
    keycloak.logout();
  };
  return (
    <header>
      <Navbar expand="xs">
        <NavbarBrand tag={isLoggedIn() ? Link : undefined} to={isLoggedIn() ? UrlPathMain : undefined}>
          <img
            src={logo}
            style={{
              height: 42,
              paddingLeft: 480,
            }}
            alt="Wolford"
          />
        </NavbarBrand>
        <Nav className="ml-auto" navbar>
          {isLoggedIn() && (
            <>
              <NavItem>
                <NavLink tag={Link} to={UrlPathBonifiedInteractions} style={{ textAlign: "center", marginTop: -15 }}>
                  <b style={{ fontSize: 24 }}>
                    <BonusPoints />
                  </b>
                  <br />
                  <span style={{ fontSize: 14 }}>Deine Punkte</span>
                </NavLink>
              </NavItem>
              <NavItem style={{ marginTop: "-15px", marginBottom: "-2px" }}>
                <Button color="link" onClick={logoutAndRedirect}>
                  <i className="bi-box-arrow-right" style={{ fontSize: 24, paddingLeft: 10 }} />
                  <br />
                  <span style={{ fontSize: 14 }}>Logout</span>
                </Button>
              </NavItem>
            </>
          )}
          <NavItem>
            <SelectTheme />
          </NavItem>
        </Nav>
      </Navbar>
    </header>
  );
};
